import React from 'react';
import PropTypes from 'prop-types';
import AIcon from '../atoms/_atoms.icon';

export default function MLoader({ className }) {
	return (
		<article className={`m-loader ${className}`}>
			<AIcon type="loader" />
		</article>
	);
}

MLoader.propTypes = {
	className: PropTypes.string,
};

MLoader.defaultProps = {
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.loader.js